import { useState } from 'react'
import styled from 'styled-components'
import Stack from 'student/projects/stack'
import { FieldTitle } from 'student/projects/repository-update/repositories-status-compontents'
import { MdClose, MdOutlineRadioButtonChecked, MdOutlineRadioButtonUnchecked } from 'react-icons/md'
import { FaGithub } from 'react-icons/fa'
import { TransparentButton as TB } from 'common/button'
import { Typography } from 'common/typography'

const ProjectStatusStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 3rem);
  .stack-tag {
    background: var(--white);
    color: var(--neutral110);
  }
  .aside-title {
    display: flex;
    justify-content: space-between;
    margin-block-end: 1rem;
  }
  .change-repository {
    color: var(--turquoise);
    text-decoration: underline;
  }
  .field-tooltip-title {
    font: var(--headline6);
  }
  .field-tooltip {
    display: flex;
    color: #FFDD66;
  }
  .form {
    position: relative;
    border-radius: 8px;
    background: transparent;
    max-width: auto;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &-restart {
      width: 24px;
      height: 24px;
      background: red;
    }
    .label-container {
      max-height: 500px!important;
    }
    &-fieldset {
      flex: 1;
      border: none;
      border: none;
      padding-inline: 0px;
      padding-block: 0px;
      margin-inline: 0px;
      width: 100%;
    }
    &-btns {
      margin-top: 60px;
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 16px;
      row-gap: 16px;
    }
    &-legend {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      color: var(--neutralText);
      opacity: .8;
      margin-bottom: 32px;
    }
    &-label {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;
      span {
        display: block;
        margin-left: 8px;
        opacity: .8;
        &:first-of-type {
          color: var(--neutralText);
        }
      }
      .bold-span {
        font-weight: 700;
      }
    }
    &-info {
      position: relative;
    }
    &-input {
      display: block;
      height: 48px;
      box-sizing: border-box;
      padding: 12px 16px;
      border-radius: 4px;
      border: 1px solid var(--neutral60);
      display: flex;
      align-items: center;
      background: var(--white);
      margin-bottom: 4px;
      max-width: calc(100vw - 64px);
      input {
        width: 100%;
        margin-left: 10px;
        background: var(--white);
        color: var(--neutral80);
        font-family: var(--primaryFont);
        outline: none;
        border: none;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        padding: 0;
        line-height: 24px;
        &::placeholder {
          color: var(--neutral60);
        }
      }
    }
    &-state {
      align-self: flex-end;
      color: var(--secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        cursor: pointer;
      }
    }
    .close {
      float: right;
    }
    .form-input {
      margin: 0;
      max-width: initial;
    }
  }
  @media(min-width: 768px) {
    .form {
      &-btns {
        position: absolute;
        right: 24px;
        bottom: 24px;
        grid-template-columns: repeat(2, min-content);
        justify-content: end;
      }
    }
  }
  a {
    color: var(--turquoise);
    transition: 200ms ease-in-out color;
    overflow-wrap: break-word;
  }
  .repo-description p {
    overflow: hidden;
    display: -webkit-box;
    margin-bottom: 0px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .level {
    display: flex;
    gap: .5rem;
    input {
      display: none;
    }
    .checked {
      display: none;
    }
    input:checked ~ .checked {
      display: block;
    }
    input:checked ~ .unchecked {
      display: none;
    }
  }
  .level-container {
    display: flex;
    gap: 2.5rem;
  }
`

function LevelSelect({ id, option, criteria, setCriteria }) {
  return (
    <label htmlFor={id} className="level">
      <input id={id} className="radio-btn" name="level" type="radio" value={id} onClick={() => setCriteria(id)} />
      {criteria === id ? (
        <MdOutlineRadioButtonChecked size="16" color="var(--turquoise)" />
      ) : (
        <MdOutlineRadioButtonUnchecked size="16" color="var(--turquoise)" />
      )}
      <span>{option}</span>
    </label>
  )
}

function ProjectStatus({ repository_slug, project_url, stack, description, username, setOpen }) {
  const [criteria, setCriteria] = useState('junior')

  return (
    <ProjectStatusStyled>
      <div className="aside-title">
        <Typography font="headline6">
          Vincula tu redes
        </Typography>
        <TB onClick={() => setOpen(false)}>
          <MdClose size={24} />
        </TB>
      </div>
      <label className="form-label" htmlFor="search_repo">
        <FaGithub size="20px" />
        <span>Github:</span>
        <span className="bold-span">
          {' '}
          {username}
        </span>
        <span className="bold-span">
          {'/'}
          {' '}
          {repository_slug}
        </span>
      </label>
      <FieldTitle title="Criterios de aceptación">
        <p className="tooltip-text">
          Selecciona los requerimientos que deseas que evaluemos.
        </p>
      </FieldTitle>
      <div className="level-container">
        <LevelSelect id="junior" option="Junior" criteria={criteria} setCriteria={setCriteria} />
        <LevelSelect id="mid" option="Mid" criteria={criteria} setCriteria={setCriteria} />
        <LevelSelect id="senior" option="Senior" criteria={criteria} setCriteria={setCriteria} />
      </div>
      <FieldTitle title="Proyecto">
        <p className="tooltip-text">
              Es la URL de demo o Deploy de tu proyecto. Esto lo encontrarás como el campo
          <b> Website </b>
              a la hora de editar el About en GitHub.
        </p>
      </FieldTitle>
      {project_url ? (
        <div className="homepage-link">
          <a href={project_url} target="_blank" rel="noopener noreferrer">{project_url}</a>
        </div>
      ) : null}
      <FieldTitle title="Stack">
        <p className="tooltip-text">
              Son las etiquetas de las tecnologías que utilizaste para desarrollar tu proyecto. Esto lo encontrarás como el campo
          <b> Topics </b>
              a la hora de editar el About en GitHub.
        </p>
      </FieldTitle>
      {stack.length !== 0 ? (
        <Stack stack={stack} />
      ) : null}
      <FieldTitle title="Descripción corta">
        <p className="tooltip-text">
              Es una reseña corta del valor y propósito del proyecto que estás desarrollando. Esto lo encontrarás como el campo
          <b> Description </b>
              a la hora de editar el About en GitHub.
        </p>
      </FieldTitle>
      <div className="repo-description">
        {description ? (
          <p>{description}</p>
        ) : null}
      </div>
    </ProjectStatusStyled>
  )
}

export default ProjectStatus
